import { sections } from "./app-search-sections/app-search-sections.config";
import { IAppSearchState } from "./app-search.types";

const MINIMUM_SEARCH_LENGTH = 1;

export const getCurrentTab = (pathname: string) =>
  Math.max(
    0,
    sections.findIndex((s) => pathname.includes(s.path))
  );

export const isSearchTermValid = (searchTerm: string) => searchTerm.length >= MINIMUM_SEARCH_LENGTH;

export const createAppSearchState = (): IAppSearchState => ({
  loaded: false,
  loading: false,
  errors: null,
  pagination: null,
  results: {},
});
